import { API } from "../axios/API";

export const convEstadoService = {
  getConvEstado,
  saveConvEstado
};

async function getConvEstado() {
  // return arrayData;
  try {
    const resp = await API.get("/convenios-estado");

    if (resp.data.length) {
      return resp?.data.map(e => {
        return {
          ...e,
          label: e.nombre,
          value: e.id
        };
      });
    }
    return resp?.data;
  } catch (err) {
    console.log(err);
    return err.response.message;
  }
}

async function saveConvEstado(data) {
  // return arrayData;
  try {
    const resp = await API.post("/convenios-estado", data);

    return resp?.data;
  } catch (err) {
    console.log(err);
    return err.response.message;
  }
}